import { FILES_ACTIONS } from '../../../redux/files/files.actions';
import { Action } from '../../../redux/redux.types';
import { GroupFilesUploadingPayload } from '../../../types/media-assets';
import { MaybeUndef } from '../../../types/system';
import {
  COMPRESS_FLOW_ACTION_NAMES,
  CompressFilesPayload,
} from '../../file-manager/compress-flow/compress-flow.actions';
import {
  FILE_MANAGER_ACTIONS,
  MultipleDownloadPayload,
} from '../../file-manager/redux/file-manager.actions';

import { ACCORDION_ACTION_NAMES } from './accordion.actions';

export interface AccordionState {
  openedItemKey: MaybeUndef<string>;
  registeredItems: string[];
}

const defaultState: AccordionState = {
  openedItemKey: undefined,
  registeredItems: [],
};

export const accordion = (
  state: AccordionState = defaultState,
  { type, payload }: Action,
): AccordionState => {
  switch (type) {
    case ACCORDION_ACTION_NAMES.TOGGLE_OPEN:
      return {
        ...state,
        openedItemKey: payload === state.openedItemKey ? undefined : payload,
      };

    case FILES_ACTIONS.FILE_GROUP_UPLOAD_START: {
      const { groupId }: GroupFilesUploadingPayload = payload;

      return {
        ...state,
        openedItemKey: groupId,
      };
    }

    case FILE_MANAGER_ACTIONS.DOWNLOAD_MULTIPLE_START: {
      const { batchClientId }: MultipleDownloadPayload = payload;

      return {
        ...state,
        openedItemKey: batchClientId,
      };
    }

    case COMPRESS_FLOW_ACTION_NAMES.COMPRESS_FILES_START: {
      const { batchClientId }: CompressFilesPayload = payload;

      return {
        ...state,
        openedItemKey: batchClientId,
      };
    }

    default:
      return state;
  }
};
